import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import AppRouter, {history} from './routers/AppRouter';
import configureStore from './store/configureStore';
import API from './components/api';
import {setWroks} from './actions/works';
import {addAboutData} from './actions/about';
import {addSettingsData } from './actions/settings';
import {addContactData } from './actions/contact'
import 'bootstrap/dist/css/bootstrap.css';
import './styles/styles.scss';
import 'react-dates/lib/css/_datepicker.css';
import LoadingPage from './components/LoadingPage';


// Google Analytics
const trackingId = "UA-146859231-1";
ReactGA.initialize(trackingId);
ReactGA.pageview(window.location.pathname + window.location.search);

export const store = configureStore();

export const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);

let hasRendered = false;
const renderApp = () =>{
    if( !hasRendered ){
        ReactDOM.render(jsx, document.getElementById('app'));
        hasRendered = true;
    }
};

ReactDOM.render(<LoadingPage />, document.getElementById('app'));


API.get(`settings`)
.then(res => {
  const SettingsData = res.data;
  store.dispatch(addSettingsData(SettingsData));
});

API.get(`work`)
.then(res => {
  const works = res.data;
  store.dispatch(setWroks(works));
  renderApp();
})
.catch(function (error) {
  // handle error
  renderApp();
  console.log("error " + error);
});

API.get(`about`)
.then(res => {
  const aboutData = res.data;
  store.dispatch(addAboutData(aboutData));
});

API.get(`contactinfo`)
.then(res => {
  const contactData = res.data;
  store.dispatch(addContactData(contactData));
});

      






// WEBPACK FOOTER //
// ./src/app.js